<template>
  <div
    style="
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
    "
  >
    <div id="tripleclick-code-container" class="code-container">
      <div
        v-for="i in 9"
        :id="`discover-button-${i}`"
        :ref="i"
        :key="i"
        class="code-button noSelect"
      >
        {{ i }}
      </div>
      <div id="tripleclick-tap-finger" class="tap-finger"></div>
    </div>
    <div class="explainer-text">Tap the top row of buttons in any order.</div>
  </div>
</template>

<script>
import gsap from 'gsap'
import lottie from 'lottie-web'
import interpolate from 'color-interpolate'

import * as tapAnimationData from '@/assets/tap_finger.json'

export default {
  name: 'TripleClickDiscovered',
  data() {
    return {
      tapAnim: undefined,
      gsapTimeline: undefined,
    }
  },
  mounted() {
    this.tapAnim = lottie.loadAnimation({
      container: document.getElementById('tripleclick-tap-finger'),
      animationData: tapAnimationData.default,
      renderer: 'svg',
      autoplay: false,
      loop: false,
    })

    /* 
    tap positions: -13% 23% 58%
    */

    const tl = gsap.timeline({ paused: true, repeat: -1, delay: 1 })
    const colourmap = interpolate(['#cdf4dd', '#468B18'])

    const callBack = () => {
      this.tapAnim.playSegments([0, 30], true)
    }
    tl.eventCallback('onStart', callBack)
    tl.eventCallback('onRepeat', callBack)

    tl.addLabel('firstTapDown', 14 / 60)
    tl.addLabel('firstTapUp', 30 / 60)

    tl.set(
      '#discover-button-1',
      {
        color: colourmap(0.4),
      },
      'firstTapDown'
    )

    tl.to(
      '#tripleclick-tap-finger',
      {
        left: '23%',
        duration: 0.5,
        onComplete: () => {
          this.tapAnim.playSegments([0, 30], true)
        },
      },
      'firstTapUp'
    )

    tl.addLabel('secondTapDown', `+=${14 / 60}`)
    tl.addLabel('secondTapUp', `+=${30 / 60}`)

    tl.set(
      ['#discover-button-1', '#discover-button-2'],
      {
        color: colourmap(0.7),
      },
      'secondTapDown'
    )

    tl.to(
      '#tripleclick-tap-finger',
      {
        left: '58%',
        duration: 0.5,
        onComplete: () => {
          this.tapAnim.playSegments([0, 30], true)
        },
      },
      'secondTapUp'
    )

    tl.addLabel('thirdTapDown', `+=${14 / 60}`)
    tl.addLabel('thirdTapUp', `+=${30 / 60}`)

    tl.set(
      ['#discover-button-1', '#discover-button-2', '#discover-button-3'],
      {
        color: colourmap(1),
      },
      'thirdTapDown'
    )

    tl.to(
      '#tripleclick-code-container',
      {
        opacity: 0,
        duration: 0.5,
      },
      'thirdTapUp+=1'
    )

    tl.set(['#discover-button-1', '#discover-button-2', '#discover-button-3'], {
      color: colourmap(0),
    })

    tl.set('#tripleclick-tap-finger', { left: '-13%' })

    tl.to(
      '#tripleclick-code-container',
      {
        opacity: 1,
        duration: 0.5,
      },
      '=+0.5'
    )

    this.gsapTimeline = tl

    setTimeout(() => {
      tl.play(0)
    }, 500)
  },
  beforeDestroy() {
    console.log('TripleClickDiscovered beforeDestroy')
    this.tapAnim.destroy()
    this.gsapTimeline.kill()
  },
}
</script>

<style scoped>
.tap-finger {
  position: absolute;
  width: 75%;
  height: 75%;
  left: -13%;
  top: -8%;
}

.code-container {
  position: relative;
  color: #cdf4dd;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: calc(clamp(0.25rem, 3vmin, 0.75rem) / 1.5);
  row-gap: calc(clamp(0.25rem, 3vmin, 0.75rem) / 1.5);
  /*column-gap: 0.75rem;*/
  /*row-gap: 0.75rem;*/
}

.code-button {
  /*width: 3rem; 
  height: 3rem;*/
  width: calc(clamp(2rem, 17.6vmin, 4.5rem) / 1.5);
  height: calc(clamp(2rem, 17.6vmin, 4.5rem) / 1.5);
  border-radius: 50%;
  border: 0.5px solid #cdf4dd;
  display: flex;
  justify-content: center;
  align-items: center;
  /*font-size: 2rem;*/
  font-size: calc(clamp(1rem, 8.8vmin, 2.5rem) / 1.5);
  font-family: 'Open Sans';
  font-weight: 100;
  cursor: pointer;
  user-select: none;
}

.explainer-text {
  font-family: 'Montserrat', sans-serif;
  color: #cdf4dd;
  margin-top: 2rem;
}

.noSelect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
</style>
